if not App.angularApp?
    return

App.angularApp.directive 'mfKeypress', ['$document', '$rootScope', ($document, $rootScope) ->
    return {
        restrict: 'A'
        link: () =>
            $document.bind 'keypress', (event) =>
                $rootScope.$broadcast 'keypress', event
                $rootScope.$broadcast "keypress:#{event.which}", event
                $rootScope.$apply()
    }
]
